/**
 * Dev-only logging helpers — in Prod stumm.
 * Für bewusste Error-Logs weiterhin console.error direkt verwenden.
 */

const isDev = process.env.NODE_ENV === 'development';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const devLog = (...args: any[]): void => {
    if (isDev) console.log(...args);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const devWarn = (...args: any[]): void => {
    if (isDev) console.warn(...args);
};
